import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import Button from "../Atomic/Atoms/Button";
import NoteForm from "../Atomic/Organisms/NoteForm";
import UserInfo from "../Atomic/Molecules/UserInfo";
import styles from "../Styles/NewNoteUI.module.css";
import { useSelector } from "react-redux";

const NewNoteUI = () => {
  const userParamName= useSelector((state) => state.ui.userParamName)
  return (
    <motion.div className={styles.new_note} >
      <nav className={styles.new_note__nav_bar}>
        <NavLink to={`/${userParamName}`}>
          <Button>Go Back</Button>
        </NavLink>
        <UserInfo />
      </nav>
      <div className={styles.new_note__body}>
        <NoteForm />
      </div>
    </motion.div>
  );
};

export default NewNoteUI;
